import { getEditableField } from '../store/selectors';
import { t } from '../../../../infra/i18n';
export var validatePromoId = function (params) {
    var state = params.store.getState();
    var isValid = true;
    var errors = [];
    var typeField = getEditableField(state, 'type');
    var isPromoCampaign = typeField.value === 'promotion';
    if (isPromoCampaign) {
        var promoCodeField = getEditableField(state, 'promoId');
        if (!promoCodeField.value) {
            isValid = false;
            errors.push({
                field: 'promoId',
                message: t('engage:validation.select_promo_code'),
            });
        }
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
